import { Box, Flex, Grid, GridItem, Text, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, Button, useDisclosure, Badge, FormLabel } from '@chakra-ui/react';
import MyDiv from './applicationGroup.style';
import { useEffect, useState } from 'react';
import { CustomButton, CustomTable, CustomToast } from '../../../../components';
import { ICompanyDropdown } from '../../Master/Branch/model';
import { useFetch } from '../../../../hooks/useFetch';
import { HrlenseInput } from '../../../../components/Input/Input';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { emptyTicketGroup, IApplicationGroup, schema } from './model';
import { MultiSelectMenu } from '../../../../components/MultiSelectMenu/MultiSelectMenu';
import { Column } from '../../../../components/CustomTable/customTable';

export default function ApplicationGroup() {
  const [tableData, setTableData] = useState<any[]>([]);

  const { addToast } = CustomToast();
  const [loading, setLoading] = useState(false)
  const { fetchApi } = useFetch(addToast);
  const [companies, setCompanies] = useState<ICompanyDropdown[]>([]);
  const [selectedCompanies, setSelectedCompanies] = useState<number[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [reload, setReload] = useState(false);
  const [selectedData, setSelectedData] = useState<any>(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const { handleSubmit, control, formState: { errors }, reset } = useForm<IApplicationGroup>({
    resolver: yupResolver(schema),
    defaultValues: selectedData || emptyTicketGroup,
    mode: "onBlur",
  });

  const handleAddNew = () => {
    setIsEditMode(false);
    setSelectedData(null);
    setSelectedCompanies([]);
    reset(emptyTicketGroup);
    onOpen();
  };

  const company = async () => {
    const response = await fetchApi("Dropdown/company", "GET");
    if (response) {
      setCompanies(response);
    }
  }

  const onSubmit = async (data: any) => {
    if (selectedCompanies.length === 0) {
      addToast({ message: "Please select at least one company", status: "warning" })
      return;
    }

    setLoading(true);
    let payLoad = {
      application_Name: data.application_Name,
      companies: selectedCompanies
    }

    const method = isEditMode ? "PUT" : "POST"
    const url = isEditMode ? `Support/ApplicationGroup/${selectedData.id}` : "Support/ApplicationGroup";
    const response = await fetchApi(url, method, payLoad,);
    if (response) {
      addToast({ message: response.message, status: 'success' });
      reset();
      loadApplicationGroup();
      setReload(!reload)
      onClose();
    }
    setLoading(false);
  }

  const loadApplicationGroup = async () => {
    const response = await fetchApi("Support/ApplicationGroup", "GET")
    if (response) {
      setTableData(response);
    }
  }

  useEffect(() => {
    company();
    loadApplicationGroup();
  }, [])

  const CompanyNamesTemplate = (rowData: any) => {
    return (
      <Flex gap={2} wrap="wrap">
        {rowData.companies.map((company: any, index: any) => (
          <Badge key={index} bg="green.400" color="white" px={3} py={1} borderRadius="md" >
            {company.company_Name}
          </Badge>
        ))}
      </Flex>
    )
  }

  const onEdit = (rowData: any) => {
    setIsEditMode(true);
    setSelectedData(rowData);

    const ids = rowData.companies.map((c: any) => c.company_Id);
    setSelectedCompanies(ids);

    reset({
      application_Name: rowData.application_Name
    });

    onOpen();
  };


  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_semibold text_3xl">Application Group List</Text>
          <Flex className="filter_section">
            {/* <InputGroup maxW="200px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input placeholder="Search name" />
            </InputGroup> */}

            <CustomButton type="button" title="Add New Group" className=' btn font-poppins text_sm text_medium' onClick={handleAddNew} />
          </Flex>
        </Flex>

        <Grid className="grid_container">
          <GridItem colSpan={12}>
            <CustomTable value={tableData} loading={loading} emptyMessage="No found.">
              <Column header="S.No" body={(_, index) => index + 1} />
              <Column header="Application Name" field='application_Name' />
              <Column header='Companies' body={CompanyNamesTemplate} />
              <Column header="Action" body={(rowData) => (
                <Text className='font-poppins text_regular text_md' color={'green'} cursor={'pointer'} onClick={() => onEdit(rowData)}>
                  Edit
                </Text>
              )} />
            </CustomTable>
          </GridItem>
        </Grid>
      </Box>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">
            {isEditMode ? "Edit Application Group" : "Add New Application Group"}
          </DrawerHeader>
          <DrawerBody>
            <Box as='form' onSubmit={handleSubmit(onSubmit)}>
              <Box mt={4}>
                <HrlenseInput isRequired label='Application Name' name='application_Name' control={control} errors={errors} />
              </Box>
              <Box mt={4}>
                <FormLabel>Companies<span style={{ color: "red" }}>*</span></FormLabel>
                <MultiSelectMenu ShowNumberOfTiles={1} placeholder="Select Companies" overflow={true} options={companies} selectedValues={selectedCompanies} setSelectedValues={setSelectedCompanies} labelKey="company_Name" valueKey="company_ID" colorScheme="green" />
              </Box>
              <DrawerFooter px={0}>
                <Button isLoading={loading} type='submit' className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>
                  {isEditMode ? "Update" : "Add"}
                </Button>
              </DrawerFooter>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  );
}
